import { axiosInstance } from "../axios";

// Answers { isSuccess, mediaKey, url } — the key is what the cover's focal point is then saved on.
export const postHeroImage = async (newImageFormData) => {
  const response = await axiosInstance.post(
    `/umbraco/api/MyAccountApi/SubmitHeroImage/`,
    newImageFormData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};
